
<script>
	import listBase from '@_system/components/base/list.vue'
	import statisticsIndex from './statistics/index.vue'
	export default {
		extends: listBase,
		name: 'operatetaskIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'operatetask',
				windowName: '运营任务',
				windowType: 'modal',
				finishitime:null
			}
		},
		render(h) {
			this.$slots.plug = [
				<statistics-index finishitime={this.finishitime} ref="statisticsIndex" />,
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			statistics() {
				let form = this.$refs[this.moduleName + '_list'].getProxyInfo().form
				this.finishitime = form.finishitime
				this.$refs.statisticsIndex.modalShow()
			
			},
		},
		components: {
			statisticsIndex
		}
	}
</script>
